// extracted by mini-css-extract-plugin
export default {"form":"login_form__r5NSv","title":"login_title__1Dfmf","card":"login_card__k84Cs"};